<template>
    <div>
      <template v-if="isIndex">
        <div class="PlaceBox">
          <!-- 标题 -->
          <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
          <!-- 搜索框 -->
          <div class="searchCon">
            <div class="searchMain">
              <ots-refer
                :selectList="selectList"
                :request-form="selectForm"
                @search="getResult"
              />
            </div>
          </div>
          <!-- 列表 -->
          <div class="mainCon">
            <ots-table-group
              :tableHeader="tableHeader"
              :tableOption="tableOption"
              :tableData="tableData"
              :batchOperBtn="batchOperBtn"
              @handleSelectionChange="bachOper"
              :pagination="pagination"
              @changeNum="changeSize"
              @changePage="changePage"
            ></ots-table-group>
          </div>
          <!-- 导入考点弹窗 -->
          <ots-custom-dialog :dialog.sync="importDialog" title="导入考点" width="40%">
            <template v-slot:content>
                <div class="exportDialog">
                    <el-form ref="exportForm" :model="importForm">
                        <el-form-item label="1.模板下载">
                            <span style="color:#006AFF;" @click="$getStaticFile('考点导入.xlsx')" class="cp">
                                <i class="el-icon-download"></i>
                                下载考点导入数据模板
                            </span>
                        </el-form-item>
                        <el-form-item label="2.考点名相同时处理方式">
                            <el-radio-group v-model="importForm.style">
                                <el-radio-button label=0>提示重复</el-radio-button>
                                <el-radio-button label=1>更新数据</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="3.选择文件" v-model="importForm.file">
                            <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
                        </el-form-item>
                    </el-form>
                    <div class="impExplain">
                        <span class="tipTitle"><i></i>提示：</span>
                        <div>
                            <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                            <div>2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；</div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <el-button round @click="importDialog=false">取消</el-button>
                <el-button round type="primary" @click="rightImport">确定</el-button>
            </template>
          </ots-custom-dialog>
          <!-- 管理机注册验证二维码 -->
          <ots-custom-dialog :dialog.sync="QRDialog" title="管理机注册验证二维码" width="40%">
            <template v-slot:content>
              <div class="QRBox">
                <img :src="QRCodeImg" alt="">
              </div>
              <p>使用微信小程序“二次验证码”进行扫码，获取注册管理机时使用的验证码</p>
            </template>
            <template v-slot:footer>
              <el-button round @click="QRDialog = false">关闭</el-button>
            </template>
          </ots-custom-dialog>
          <!-- 关联教学点弹窗 -->
          <ots-custom-dialog :dialog.sync="stationInfo.stationDialog" title="关联教学点" width="55%">
            <template v-slot:content>
              <div v-if="stationInfo.stationList && stationInfo.stationList.length > 0">
                <p class="stationTitle">{{ stationInfo.stationName }}</p>
                <div class="items-grid" style="padding-left: 20px;">
                  <div v-for="(item, index) in stationInfo.stationList" :key="index">
                    {{ item }}
                  </div>
                </div>
              </div>
              <div v-else>
                <p>{{ stationInfo.stationName }}</p>
                <div>当前没有教学点数据</div>
              </div>
            </template>
            <template v-slot:footer>
              <el-button round @click="stationInfo.stationDialog = false">关闭</el-button>
            </template>
          </ots-custom-dialog>
        </div>
      </template>
      <template v-else>
        <router-view></router-view>
      </template>
    </div>
</template>
<script>
import { getAllPlace, addPlaceFn, updatePlaceFn, deletePlaceFn, updatePlaceStateFn, importPlaceFn, getPlaceMonitorQrCodeAPI, exportPlaceMonitorQrCodeAPI } from '@/http/modules/baseSet/examSite'

export default {
  name: 'examSite',
  data () {
    return {
      /* ** 勾选ID ** */
      selectIds: [],

      /* ** 搜索表单配置 ** */
      selectList: [
        {
          title: "状态",
          type: "select",
          requestKey: "state",
          label: 'key',
          value: 'value',
          data: [
            { key : '全部', value : -1 },
            { key : '启用', value : 1 },
            { key : '停用', value : 0 }
          ],
        },
        {
          title : '考点名称',
          type : 'input',
          placeholder : '请输入考点名称',
          requestKey: "searchKey"
        }
      ],
     
      /* ** 搜索表单参数 ** */
      
      selectForm: {
        state : -1,
        searchKey : '',
      },

      /* ** 表格头配置 ** */
      tableHeader: [
          {
              title: "考点名称",
              prop: "name"
          },
          {
              title: "考点地址",
              prop: "address"
          },
          {
              title: "教室",
              type: 'button',
              prop: "classCount",
              formatter: (val) => val.row.classCount == 0 ? '<span>添加</span>' : val.row.classCount,
              disableFn: (val) => val.row.state == 1? false : true,
              click: this.addClass
          },
          {
              title: "教学点",
              type: 'button',
              prop: "stationCount",
              formatter: (val) => val.row.stationNameList && val.row.stationNameList.length > 0 ? val.row.stationNameList.length : 0,
              disableFn: (val) => val.row.stationNameList && val.row.stationNameList.length > 0 ? false : true,
              click: this.showStation
          },
          {
              title: "联系人",
              prop: "contact"
          },
          {
              title: "联系电话",
              prop: "phone"
          },
          {
              title:"启用状态",
              prop:"state",
              type:"switch",
              switchChange:this.changePlaceState
          },
          {
              title: "管理机注册验证二维码",
              type: 'button',
              prop: "classCount",
              formatter: (val) => '<span>查看</span>',
              click: this.viewQRCode
          },
          {
              title:"操作",
              type:"buttons",
              width:"100",
              btnList:[
                  {
                    title:"编辑",
                    click: this.editPlace
                  },
                  {
                    title:"删除",
                    click: this.deletePlace
                  },
              ]
          }
      ],

      /* ** 开启勾选功能 ** */
      tableOption: {
          multiple:true
      },

      /* ** 按钮 ** */
      batchOperBtn:[
        {
          title: "删除",
          icon: "iconfont icon-shanchu",
          click: this.deletePlace
        },
        {
          title: "导出管理机注册验证二维码",
          click: this.exportQRCodes
        },
      ],

      /* ** 表格数据 ** */
      tableData: [],

      /* ** 表单数据 ** */
      form: {
      
        name: '',
        state: 1,
      },

      /* ** 文件表单 ** */
      importForm: {
        file: '',
        style: 0,

      },
      /* ** 表单校验 ** */
      mainTopBtnList: [
        {
          title: '新增',
          fn: this.goAddPlace,
          plain: true
        },
        {
          title: '导入',
          fn: this.importPlaceDialog
        }
      ],

      addDialog: false,

      importDialog: false,

      siteName: "",
      QRDialog: false,
      QRCodeImg: "",

      pagination: {
        total: 0
      },

      PlaceListParams: {
        orders: 'createDate desc',
        page: 1, 
        size: 10
      },

      stationInfo:{
        stationDialog: false,
        stationName: '',
        stationList: [],
      }
    }
  },
  computed: {
    isIndex () {
      return this.$route.name == 'examSite'
    },
  },
  watch: {
    '$route':'getPath'
  },
  created () {
    this.getAllPlaceFn() 
  },
  methods: {
    // 查看二维码
    async viewQRCode(row) {
      let { id } = row;
      this.siteName = row.name;
      const { data } = await getPlaceMonitorQrCodeAPI({id});
      this.QRCodeImg = data;
      this.QRDialog = true;
    },
    // 导出二维码
    async exportQRCodes(row) {
      if (!this.beforeBatch()) {
        return false;
      }
      let param = {
        ids: row ? row.id : this.selectIds.join()
      }
      const { code, data } = await exportPlaceMonitorQrCodeAPI(param);
      if (code !== 1) {
        this.$message.error('管理机注册验证二维码导出失败！');
      } else {
        window.open(data);
      }
    },

    /* ** 教室按钮 ** */
    addClass (row) {
      this.$router.push({
        name: 'classroom',
        query: {
          type: row.classCount > 0 ? 'search' : 'add',
          siteId: row.id
        }
      })
    },

    /* ** 查询 ** */
    getPath () {
      if (this.$route.name == 'examSite') {
        this.getAllPlaceFn();
      }
    },

    bachOper (val) {
      let idList=[]
      val.forEach(item=>{
        idList.push(item.id) 
      })
      this.selectIds = idList
    },

    goAddPlace () {
      this.$router.push({
        name: 'addSite'
      })
    },

    importPlaceDialog () {
      this.importDialog = true
    },

    addPlace () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let params = {...this.form}
          for (let key in params) {
            if (key.startsWith('form_')) {
              delete params[key]
            }
          }
          const useFn = params.id ? updatePlaceFn : addPlaceFn
          const { code } = await useFn(params)
          if (code ==  1) {
            this.$message.success('操作成功')
            this.addAfter()
          }
        } else {
          return false
        }
      })
    },


    editPlace (row) {
      this.$router.push({
        name: 'editSite',
        query: {
          id: row.id
        }
      })
    },

    /* ** 是否勾选考点 ** */
    beforeBatch () {
      if (this.selectIds.length > 0) {
        return true
      } else {
        this.$message.warning('请先选择考点！')
        return false
      }
    },

    /* ** 删除考点 ** */
    deletePlace (row) {
      if (row || this.beforeBatch()) {
      } else {
        return false
      }
      let param = {
        ids: row ? row.id : this.selectIds.join()
      }
      this.$confirm('确定删除该考点?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { code } = await deletePlaceFn(param)
        if (code == 1) {
          this.$message.success('删除成功')
          this.getAllPlaceFn()
        }
      }).catch(() => {        
      })
    },

    /* ** 切换使用状态 ** */
    async changePlaceState (row) {
      let param = {
        id: row.id,
        state: row.state
      }
      const { code } = await updatePlaceStateFn(param)
      if (code == 1) {
        this.$message.success('修改成功')
        this.getAllPlaceFn()
      }
    },

    /* ** 获取考点信息 ** */
    async getAllPlaceFn () {
      this.PlaceListParams = Object.assign(this.PlaceListParams, this.selectForm)
      const { data } = await getAllPlace(this.PlaceListParams)
      this.tableData = data.records
      this.pagination.total = data.total
    },

    /* ** 重置表单数据 ** */
    resetForm() {
      this.form = {
        name: '',
        state: 1,
      }
    },

    addAfter () {
      this.addDialog = false
      this.resetForm()
      this.getAllPlaceFn()
    },
    changeSize(num) {
        this.PlaceListParams.size=num
        this.getAllPlaceFn()
    },
    changePage(p) {
        this.PlaceListParams.page=p
        this.getAllPlaceFn()
    },
    getResult () {
      this.PlaceListParams.page = 1
      this.getAllPlaceFn()
    },
    handleFormData (val) {
        this.importForm.file = val.file
    },
    async rightImport () {
        if (!this.importForm.file) {
            this.$message.error('请选择文件')
            return
        }
        const fd = new FormData()
        for (let item in this.importForm) {
            fd.append(item,this.importForm[item])
        }
        const { code, data } = await importPlaceFn(fd)
        if (code == 1) {
            const failNum = data.errorCount ? parseInt(data.errorCount) : 0
            const totalNum = parseInt(data.allCount)
            const successNum = totalNum - failNum

            let message = `导入完成，成功导入${successNum}条，失败${failNum}条。`
            this.importDialog = false

            this.$confirm(message, '导入结果', {
                confirmButtonText: failNum > 0 ? '查看错误记录' :'确定',
                 cancelButtonText: '取消',
                type: failNum > 0 ? 'warning' :'success'
            }).then(async () => {
                if (failNum > 0) {
                    window.location.href = data.address
                }
            }).catch(() => {
            });
            this.getAllPlaceFn()
        }
    },
    async showStation(row){
      this.stationInfo.stationName = row.name;
      this.stationInfo.stationList = row.stationNameList;
      this.stationInfo.stationDialog = true;
    }
  },
}
</script>
<style lang="less" scoped>
.QRBox {
  img {
    width: 100%;
  }
}

.PlaceBox {
  .searchCon {
    // padding: 20px;
    margin-bottom: 16px;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    .searchMain {
      flex: 1;
    }
    .searchBtn {
      flex-shrink: 0;
      width: 72px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .mainCon {
    padding: 20px;
    border-radius: 8px;
    background-color: #fff;
  }
}
.tipIcon{
    position: relative;
    .tips {
      font-size: 13px;
      position: absolute;
      color: #fff;
      width: 176px;
      text-align: center;
      padding: 10px;
      top: -48px;
      left: -90px;
      background: rgba(0, 0, 0, 0.85);
    }
    .tips::after{
      content: '';
      border: 5px solid transparent;
      border-top-color: rgba(0, 0, 0, 0.85);
      position: absolute;
      top: 33px;
      left: 96px;
    }
}
.stationTitle{
  font-size: 20px;
  font-weight: bold;
  height: 50px;
}
.items-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
</style>